import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center', {
        url: '/request-center',
        component: 'requestCenter',
        redirectTo: 'company.request-center.list',
        resolve: {requests},
    })
}

/** @ngInject */
function requests(AccessRequestsService, $stateParams) {
    return AccessRequestsService.getRequestsForCompany($stateParams.companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/request-center.state.js